import { useQuery } from "@tanstack/react-query";

import { FacilityReportData } from "../../../models/FacilityReportData";
import DataSvc from "../../../services/dataSvc";

export const useFacilityReport = (facilityReportId: string) => {
  const query = useQuery<FacilityReportData>(
    ["facilityReport", facilityReportId],
    () => DataSvc.getFacilityReport(facilityReportId)
  );

  return query;
};
